module.exports = "<div class=\"col s12 m6\"> <card-panel class=teal> <span class=white-text>I am a very simple card. I am good at containing small bits of information. I am convenient because I require little markup to use effectively. I am similar to what is called a panel in other frameworks. </span> </card-panel> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/cards/card-panel.vue
 ** module id = 186
 ** module chunks = 0
 **/